import { bcp } from './Bcp';

export class BcpEventService {
  getEventPlayers = async (eventId) => {
    const response = await bcp.get(`events/${eventId}/players`);
    return { data: response.active || [] };
  };

  getArmyList = async (armyId) => {
    return bcp.get(`https://newprod-api.bestcoastpairings.com/v1/armylists/${armyId}`);
  };

  getTeamPairings = async (round) => {
    return await bcp.get(
      `pairings?limit=500&eventId=Zh1yiB7Qlv06&round=${round}&pairingType=TeamPairing&expand%5B%5D=teamPlayer1&expand%5B%5D=teamPlayer2&expand%5B%5D=player1Game&expand%5B%5D=player2Game`
    );
  };
  getPairings = async () => {
    const round1 = bcp.get(
      `pairings?limit=500&eventId=Zh1yiB7Qlv06&round=1&pairingType=Pairing&expand%5B%5D=player1&expand%5B%5D=player2&expand%5B%5D=player1Game&expand%5B%5D=player2Game`
    );
    const round2 = bcp.get(
      `pairings?limit=500&eventId=Zh1yiB7Qlv06&round=2&pairingType=Pairing&expand%5B%5D=player1&expand%5B%5D=player2&expand%5B%5D=player1Game&expand%5B%5D=player2Game`
    );
    const round3 = bcp.get(
      `pairings?limit=500&eventId=Zh1yiB7Qlv06&round=3&pairingType=Pairing&expand%5B%5D=player1&expand%5B%5D=player2&expand%5B%5D=player1Game&expand%5B%5D=player2Game`
    );
    const round4 = bcp.get(
      `pairings?limit=500&eventId=Zh1yiB7Qlv06&round=4&pairingType=Pairing&expand%5B%5D=player1&expand%5B%5D=player2&expand%5B%5D=player1Game&expand%5B%5D=player2Game`
    );
    const round5 = bcp.get(
      `pairings?limit=500&eventId=Zh1yiB7Qlv06&round=5&pairingType=Pairing&expand%5B%5D=player1&expand%5B%5D=player2&expand%5B%5D=player1Game&expand%5B%5D=player2Game`
    );
    const round6 = bcp.get(
      `pairings?limit=500&eventId=Zh1yiB7Qlv06&round=6&pairingType=Pairing&expand%5B%5D=player1&expand%5B%5D=player2&expand%5B%5D=player1Game&expand%5B%5D=player2Game`
    );
    const round7 = bcp.get(
      `pairings?limit=500&eventId=Zh1yiB7Qlv06&round=7&pairingType=Pairing&expand%5B%5D=player1&expand%5B%5D=player2&expand%5B%5D=player1Game&expand%5B%5D=player2Game`
    );

    const result = await Promise.all([round1, round2, round3, round4, round5, round6, round7]);

    return [
      result[0].data,
      result[1].data,
      result[2].data,
      result[3].data,
      result[4].data,
      result[5].data,
      result[6].data,
    ];
  };
  getTeams = async () => {
    const eventId = 'Zh1yiB7Qlv06';
    
    const teamsResponse = await bcp.get(`events/${eventId}/teamplayers`);
    const teams = teamsResponse.active || [];

    const placingsResponse = await bcp.get(`teamplayers?limit=100&eventId=${eventId}&placings=true`);
    const placings = placingsResponse.data || [];

    const playersResponse = await bcp.get(`events/${eventId}/players`);
    const allPlayers = playersResponse.active || [];

    const allTeams = teams.map((team) => {
      const teamPlayers = allPlayers.filter((player) => player.teamPlayerId === team.id);
      const placing = placings.find((placing) => placing.id === team.id)?.placing || '-';
      const battlePoints = placings.find((placing) => placing.id === team.id)?.battlePoints || '-';
      return { ...team, placing: placing, battlePoints: battlePoints, players: teamPlayers };
    });
    return allTeams;
  };
  getEventMetrics = async (eventId) => {
    return bcp.get(`events/${eventId}?&expand%5B%5D=location&expand%5B%5D=gameStore`);
  };
}

export const bcpEventService = new BcpEventService();
